import { EstateType } from "@1games-ru/region-shared/dist/enums/estate/estate";

// small:  134 / 80
// medium: 480 / 240
// large:  740 / 260
export default function getEstateImage(
  estate: {
    id: number;
    type: EstateType;
    complexId?: number;
  },
  size: "small" | "medium" | "large" | "original",
): string {
  const cdnUrl = import.meta.env.VITE_CDN_URL || "https://cdn.region.game/";
  const serverName = import.meta.env.VITE_SERVER_NAME || "arzamas";

  if (estate.type === EstateType.Apartment && estate.complexId) {
    return [cdnUrl, "server/", serverName, "/complexes/", estate.complexId, `/${size}.jpg`].join(
      "",
    );
  }

  return [cdnUrl, "server/", serverName, "/houses/", estate.id, `/${size}.jpg`].join("");
}
